import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

export const itemsSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload;
    },
    emptyItems: (state) => {
      state.items = [];
    },
  },
});

export const { setItems, emptyItems } = itemsSlice.actions;

export default itemsSlice.reducer;
